export default "__VITE_ASSET__l0ynVPAw__"